DashboardRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function DashboardRouting($urlRouterProvider, $stateProvider) {

 $urlRouterProvider.otherwise("/Dashboard/Index");

  $stateProvider

  .state('Dashboard',{

   abstract: true,

  url: '/Dashboard',

  template: '<ui-view id="Dashboard"></ui-view>'

    })

  .state('Dashboard.Index',{

  url: '/Index',

  controller: 'IndexController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./Index/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./Index/Index.module');

            $ocLazyLoad.load({

                name: 'IndexModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  }

    })/*endOfResolve*/ ;

}



export default DashboardRouting;